import { Route, Routes } from "react-router-dom";

import { useGetProfile } from "../libs/api/react-query";

import PrivateRoute from "./PrivateRoute";

import {
  PermissionsAction,
  PermissionsPosModule,
  PermissionsScope
} from "@/common/types/permissions.types";
import ListComplementaryDocuments from "@/modules/ComplementaryDocuments";
import { ViewProxyDocument } from "@/modules/ComplementaryDocuments/pages/proxy/view";
import { ViewComplementaryDocuments } from "@/modules/ComplementaryDocuments/pages/view-complementary-documents";

function ComplementaryDocumentsRoute(): JSX.Element {
  const userProfileQuery = useGetProfile();
  const permissions = userProfileQuery.data?.data?.role.permissions || [];

  return (
    <Routes>
      <Route
        path="proxy/:id"
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.TERMS}
            action={PermissionsAction.LIST}
          >
            <ViewProxyDocument />
          </PrivateRoute>
        }
      />

      <Route
        index
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.TERMS}
            action={PermissionsAction.LIST}
          >
            <ListComplementaryDocuments />
          </PrivateRoute>
        }
      />

      <Route
        path=":id"
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.TERMS}
            action={PermissionsAction.LIST}
          >
            <ViewComplementaryDocuments />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default ComplementaryDocumentsRoute;
